module.exports = __webpack_public_path__ + "static/media/scene7_sama1.e24c3bc4.wav";